module.exports = __webpack_public_path__ + "ui-ok.adbc2a4c.mp3";